import React from "react";
import PropTypes from "prop-types";

/**
 * Composant réutilisable pour un switch (toggle) style DaisyUI.
 * - isEnabled (bool) contrôle l'état (coché / décoché).
 * - onToggle (func) est appelée lors du clic sur le toggle.
 * - label (string) texte à afficher à gauche du toggle (peut provenir de `t("...")`).
 * - colorActive et colorInactive (string) classes Tailwind pour la couleur.
 * - className (string) vous permet d'ajouter des classes DaisyUI supplémentaires, ex: "toggle toggle-lg".
 */
const ToggleSwitch = ({
  isEnabled,
  onToggle,
  labelOn,
  labelOff,
  colorActive,
  colorInactive,
  className,
  title,
  name,
}) => {
  const currentLabel = isEnabled ? labelOn : labelOff;
  return (
    <div className="form-control">
      {/* Titre */}
      {title && <label className="block text-sm font-medium">{title}</label>}

      {/* Toggle */}
      <label className="label cursor-pointer flex items-center justify-start space-x-2">
        <input
          type="checkbox"
          checked={isEnabled}
          onChange={onToggle}
          name={name}
          className={`toggle cursor-pointer 
          ${
            isEnabled
              ? "[--tglbg:theme(colors.green.200)] checked:bg-green-200 hover:bg-green-300"
              : "bg-red-300 hover:bg-red-400"
          }
        `}
        />
        {currentLabel && <span className="label-text">{currentLabel}</span>}
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string,
  colorActive: PropTypes.string,
  colorInactive: PropTypes.string,
  className: PropTypes.string,
};

ToggleSwitch.defaultProps = {
  label: "",
  colorActive: "bg-green-50",
  colorInactive: "bg-red-500",
  className: "",
};

export default ToggleSwitch;
